import isApplicableWithOffer from './isApplicableWithOffer';
/**
 *
 * @param {Offers} offers
 * @param {object} colorBadgeIds
 * @returns {Offers}
 */
function _filterOffersByColor(offers, colorBadgeIds) {
  if (!Array.isArray(offers) || !Array.isArray(colorBadgeIds)) {
    return offers;
  }

  return offers.filter(
    (offer) => offer.applicableToAllUpcs || colorBadgeIds.includes(offer.promoId),
  );
}
/**
 * Filters active offers
 * @param {Offers} offers
 * @returns {Offers}
 */
function _getActiveOffers(offers) {
  if (!Array.isArray(offers)) return [];

  return offers.filter((offer) => offer.active);
}

/**
 * Getting applicable Offers data based on colorBadges and flags
 * @param {object} data
 * @param {Offers} data.offers
 * @param {FinalPrice} data.finalPrice
 * @param {string[]} data.colorBadges
 * @param {object} data.flags
 * @param {boolean} data.flags.isColorwayOffers
 * @param {boolean} data.flags.isMasterProduct
 * @returns {OffersData}
 */
function getOffersData({
  offers, finalPrice, colorBadges, flags,
}) {
  const { isColorwayOffers, isMasterProduct } = flags;
  const activeOffers = _getActiveOffers(offers);

  let withOffer;
  let withOfferPosition = 0;
  let filteredOffersByColor = activeOffers;

  if (isColorwayOffers && colorBadges.length) {
    filteredOffersByColor = _filterOffersByColor(activeOffers, colorBadges);
  }
  if (
    finalPrice
        && !finalPrice.maskPromotion
        && filteredOffersByColor.length
        && isApplicableWithOffer(filteredOffersByColor, finalPrice)
  ) {
    withOffer = finalPrice;
    withOfferPosition = 1;
  }

  let regularOffers = filteredOffersByColor.slice(withOfferPosition);

  if (!isMasterProduct) {
    regularOffers = regularOffers.filter((offer) => !offer.promoCode);
  }

  return {
    lists: {
      activeOffers,
      selectedColorOffers: _filterOffersByColor(activeOffers, colorBadges),
    },
    withOffer,
    regularOffer: regularOffers[0],
    isMultipleOffers: regularOffers.length > 1,
  };
}

export default getOffersData;
